import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';
import { Z_INDEX } from '@/components/shared/constants/zIndex';
import { FloatingBannerWrapper } from '../common.StyledComponents';

const VARIANT_COLORS = {
    pending: { bg: '#e1f0f9', border: '#b8d8ea', color: '#2679ad' },
    missing: { bg: '#fee2e2', border: '#fecaca', color: '#991b1b' },
} as const;

type DeepLinkBannerVariant = keyof typeof VARIANT_COLORS;

const TOP_OFFSET = 64;

export const BannerWrapper = styled(FloatingBannerWrapper)<{ variant: DeepLinkBannerVariant }>`
    top: ${rem(TOP_OFFSET)};
    z-index: ${Z_INDEX.DEEP_LINK_BANNER};
    color: ${({ variant }) => VARIANT_COLORS[variant].color};
    background-color: ${({ variant }) => VARIANT_COLORS[variant].bg};
    border: 1px solid ${({ variant }) => VARIANT_COLORS[variant].border};
`;
